import A11yDialog from 'a11y-dialog';
import Cookies from 'js-cookie';
import isbot from 'isbot';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-dialog]').forEach((el) => {
    const noticeId = el.getAttribute('id');
    const expiresHours = el.getAttribute('data-expires')
      ? parseFloat(el.getAttribute('data-expires'))
      : 2;
    const expiresDays = expiresHours / 24;
    const dialog = new A11yDialog(el, document.getElementById('main'));

    function init() {
      if (!isbot(navigator.userAgent)) {
        if (expiresDays && Cookies.get(noticeId) === undefined) {
          dialog.show();
          Cookies.set(noticeId, 1, { expires: expiresDays });
        }
      }
    }

    init();

    // Add any event handlers here...
    // See https://github.com/edenspiekermann/a11y-dialog#js-api
  });

  document.querySelectorAll('[data-controls-dialog]').forEach((el) => {
    // console.log(el);
    const dialogId = el.getAttribute('aria-controls');
    // console.log(dialogId);
    const dialogEl = document.querySelector('#' + dialogId);
    if (dialogEl) {
      const dialog = new A11yDialog(dialogEl, document.getElementById('main'));

      if (dialog) {
        el.addEventListener('click', (e) => {
          dialog.show();
          const video = dialogEl.querySelector('.video-placeholder__thumbnail');
          if (video) video.click();
        });

        dialog.on('hide', function (event) {
          const element = event.target;
          if (element) {
            const video = element.querySelector('iframe');
            if (video) {
              const src = video.src;
              video.src = 'about:blank';
              video.src = src;
            }
          }
        });
      }
    }
  });
});
